export const ADDPRODUCT = "product/addProduct";
export const PRODUCTTOCART = "product/addProductToCart";
export const PRODUCTINCREMENT = "product/productIncrement";
export const PRODUCTDECREMENT = "product/productDecrement";
export const PRODUCTREMOVED = "product/productRemoved";
